import { render, staticRenderFns } from "./proReviewCptsPivot.vue?vue&type=template&id=b09b969c&scoped=true&"
import script from "./proReviewCptsPivot.vue?vue&type=script&lang=js&"
export * from "./proReviewCptsPivot.vue?vue&type=script&lang=js&"
import style0 from "./proReviewCptsPivot.vue?vue&type=style&index=0&id=b09b969c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09b969c",
  null
  
)

export default component.exports